import api from '../../api/apiClient';
import { User } from '../../auth/session';

const unwrap = async <T>(promise: Promise<{ data: T }>): Promise<T> => {
  const res = await promise;
  return res.data;
};

/**
 * Mirrors `AuthController.LoginDto` — the backend authenticates on
 * username + password only. There is no OTP grant on the API.
 */
export interface LoginCredentials {
  username: string;
  password: string;
}

/** Mirrors `AuthController.ResetPasswordDto`. */
export interface ResetPasswordPayload {
  username: string;
  oldPassword: string;
  password: string;
  passwordConfirmation: string;
}

/** `POST /api/auth/login` success body. */
export interface LoginResponse {
  status: boolean;
  message: string;
  token: string;
  user: User;
}

/** `GET /api/auth/session-status` success body. */
export interface SessionStatusResponse {
  success: boolean;
  isValid: boolean;
  message: string;
  user: User;
  token: string;
}

export const login = (credentials: LoginCredentials): Promise<LoginResponse> =>
  unwrap(api.post('/api/auth/login', credentials));

export const resetPassword = (payload: ResetPasswordPayload): Promise<any> =>
  unwrap(api.post('/api/auth/reset-password', payload));

export const logout = (): Promise<any> => unwrap(api.post('/api/auth/logout'));

export const sessionStatus = (): Promise<SessionStatusResponse> =>
  unwrap(api.get('/api/auth/session-status'));

const authApi = { login, logout, resetPassword, sessionStatus };

export default authApi;
